import store from '../data/store/store';

/**
 * Function which returns the value of the option from the store
 */
export default function getSelectedAccessibilityOption(): boolean {
    return store().isEnabled;
}
